import Dexie from 'dexie';

// DB 생성
const db = new Dexie('LectureTranslationsDB');

// 스키마 정의
db.version(1).stores({
    translations: 'filterKey, savedAt, ttl', // filterKey로 조회
    lastTimestamps: 'filterKey'
});

export default db;
